import { getAuthAxiosBackend } from "@/helpers/axios"

class DepartmentsServices {
    get(id) {
        return getAuthAxiosBackend().get('Departments/getDepartmentsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('Departments/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('Departments/addDepartments', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('Departments/updateDepartments/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('Departments/restoreDepartments' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('Departments/softDeleteDepartments/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('Departments/deleteDepartments/' + id.toString())
    }
}

export default new DepartmentsServices()
